import { AdminCompany } from '../types';
import { api } from '../../../../core/utils/apiClient';

export class AdminCompaniesService {
  async getAllCompanies(): Promise<AdminCompany[]> {
    try {
      const response = await api.get('/api/v1/companies/');
      if (response.ok) {
        const data = await response.json();
        return data.companies || [];
      }
      return [];
    } catch (error) {
      console.error('Error fetching companies:', error);
      return [];
    }
  }

  async getCompanyById(companyId: number): Promise<AdminCompany | null> {
    try {
      const response = await api.get(`/api/v1/companies/${companyId}`);
      if (response.ok) {
        return await response.json();
      }
      return null;
    } catch (error) {
      console.error('Error fetching company:', error);
      return null;
    }
  }

  async createCompany(companyData: Partial<AdminCompany>): Promise<AdminCompany | null> {
    try {
      const response = await api.post('/api/v1/companies/', companyData);
      if (response.ok) {
        return await response.json();
      }
      return null;
    } catch (error) {
      console.error('Error creating company:', error);
      return null;
    }
  }

  async updateCompany(companyId: number, companyData: Partial<AdminCompany>): Promise<AdminCompany | null> {
    try {
      const response = await api.put(`/api/v1/companies/${companyId}`, companyData);
      if (response.ok) {
        return await response.json();
      }
      return null;
    } catch (error) {
      console.error('Error updating company:', error);
      return null;
    }
  }

  async deleteCompany(companyId: number): Promise<boolean> {
    try {
      const response = await api.delete(`/api/v1/companies/${companyId}`);
      return response.ok;
    } catch (error) {
      console.error('Error deleting company:', error);
      return false;
    }
  }
}

export const adminCompaniesService = new AdminCompaniesService();

